import HighlightPhraseFilter from './HighlightPhraseFilter';
import prettyPhoneNumber from './prettyPhoneNumber';

export default angular.module('edge.platform.filters', ['edge.platform.l10n']).filter('highlightPhrase', HighlightPhraseFilter).filter('gwPrettyPhoneNumber', prettyPhoneNumber);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/filters/module.js
// module id = 1034
// module chunks = 0